import React from 'react';
import MeasureToggle from '../measureToggle.jsx';

export default ({ changeMeasure, retailNettMeasure }) => (
  <div style={{ color: 'rgba(0, 0, 0, 0.87)', display: 'inline-block', width: '35%', marginLeft: '40%', fontSize: '12px' }}>
    DISCOUNT
    <div style={{ width: '40%', display: 'inline-block', marginLeft: '5%' }}>
      <MeasureToggle changeMeasure={changeMeasure} retailNettMeasure={retailNettMeasure} />
    </div>
  </div>);



// WEBPACK FOOTER //
// ./src/app/components/contracting/mass-rate-change/middle-action-area/header/discount.jsx